module.exports = __webpack_public_path__ + "static/media/incident_category-war.8fa36c9d.svg";